var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgSite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.646,
    height: 25.646,
    viewBox: "0 0 25.646 25.646",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7835.969 23667.344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.073.25a12.823,12.823,0,0,1,9.068,21.891A12.823,12.823,0,0,1,4.007,4.006,12.738,12.738,0,0,1,13.073.25Zm0,24.146A11.323,11.323,0,1,0,1.751,13.073,11.336,11.336,0,0,0,13.073,24.4Z",
    transform: "translate(-7836.22 -23667.594)",
    fill: "#73a91b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.328.25c2.037,0,3.915,1.4,5.289,3.929a19.019,19.019,0,0,1,2.008,8.894,19.019,19.019,0,0,1-2.008,8.895C24.243,24.5,22.365,25.9,20.328,25.9s-3.915-1.4-5.288-3.928a19.019,19.019,0,0,1-2.008-8.895,19.019,19.019,0,0,1,2.008-8.894C16.413,1.645,18.291.25,20.328.25Zm0,24.146c1.461,0,2.871-1.116,3.97-3.144a17.508,17.508,0,0,0,1.827-8.179A17.508,17.508,0,0,0,24.3,4.894c-1.1-2.027-2.509-3.144-3.97-3.144s-2.87,1.117-3.97,3.144a17.508,17.508,0,0,0-1.827,8.179,17.508,17.508,0,0,0,1.827,8.179C17.457,23.28,18.867,24.4,20.328,24.4Z",
    transform: "translate(-7843.475 -23667.594)",
    fill: "#73a91b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.146.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H24.146A.75.75,0,0,1,24.9,0,.75.75,0,0,1,24.146.75Z",
    transform: "translate(-7835.219 -23654.521)",
    fill: "#73a91b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.317,15.428c-5.895,0-8.835-1.6-10.062-2.558a.75.75,0,1,1,.921-1.184c1.076.837,3.694,2.242,9.141,2.242s8.066-1.4,9.142-2.242a.75.75,0,1,1,.921,1.184C25.152,13.825,22.212,15.428,16.317,15.428Z",
    transform: "translate(-7839.463 -23673.998)",
    fill: "#73a91b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.919,43.171a.747.747,0,0,1-.46-.158c-1.076-.837-3.694-2.241-9.142-2.241s-8.065,1.4-9.141,2.241a.75.75,0,1,1-.921-1.184c1.227-.955,4.167-2.558,10.062-2.558s8.836,1.6,10.063,2.558a.75.75,0,0,1-.461,1.342Z",
    transform: "translate(-7839.463 -23689.746)",
    fill: "#73a91b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,24.855a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V24.1A.75.75,0,0,1,0,24.855Z",
    transform: "translate(-7823.146 -23666.594)",
    fill: "#73a91b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgSite);
export default __webpack_public_path__ + "static/media/svg-site.a0589a3a8f519f780900beca77091443.svg";
export { ForwardRef as ReactComponent };